import React, { FC } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { PrivateUIRoutes } from "../../router";
import { ISystemSetting } from "../../models/system-setting.model";
import { IResultResponse } from "../../models/response/result.model";

const List: FC = () => {
  const { fetchedData, loading } = useHttpGet<
    IResultResponse<ISystemSetting[]>
  >(`${APIRoutes.SYSTEM_SETTINGS}`, {
    defaultValue: {} as IResultResponse<ISystemSetting[]>,
    reject: CommonService.showAllErrors,
  });

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      render: (text: string) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
    {
      title: "",
      dataIndex: "id",
      render: (text: any, record: ISystemSetting) => {
        return (
          <Link
            className="c-blue"
            to={`/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.SYSTEM_SETTINGS}/${record?.id}`}
          >
            Edit
          </Link>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={fetchedData.result || []}
      pagination={false}
      rowKey="id"
      loading={loading}
      size="small"
    />
  );
};

export default List;
